import styled from 'styled-components';

const ShoppingCartSummaryStyled = styled.div`
  padding: 24px 16px;
  background-color: #fafafa;

  .ShoppingCartSummary {
    &__title {
      font-size: 12px;
      color: #6b6b6b;
      padding-bottom: 12px;
    }

    &__summary {
      .ShoppingCartItem {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 6px 0;
        font-size: 12px;

        &:last-child {
          padding-bottom: 0;
          font-size: 12.8px;
          font-weight: 600;
        }
      }
    }
  }
`;

export { ShoppingCartSummaryStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
